var map = {
	"./LogoPng.png": 1872,
	"./PNGLOGO.png": 7846,
	"./WhatsApp Image 2026-04-05 at 18.46.59 (1).jpeg": 6061,
	"./WhatsApp Image 2026-04-05 at 18.46.59.jpeg": 9175,
	"./WhatsApp Image 2026-04-05 at 18.47.00 (1).jpeg": 730,
	"./WhatsApp Image 2026-04-05 at 18.47.00 (3).jpeg": 3944,
	"./WhatsApp Image 2026-04-05 at 18.47.00.jpeg": 2672,
	"./about1.jpg": 6236,
	"./about2.jpg": 3211,
	"./about3.jpg": 1902,
	"./about4.jpg": 9237,
	"./au.jpg": 26,
	"./author.jpg": 5197,
	"./contact-bg.jpg": 668,
	"./creation1.jpg": 1510,
	"./creation2.jpg": 9281,
	"./creation3.jpg": 5556,
	"./hero.jpg": 4480,
	"./image00002.jpeg": 4656,
	"./image00006.jpeg": 8276,
	"./image00007.jpeg": 4267,
	"./image00008.jpeg": 5234,
	"./image00009.jpeg": 7449,
	"./image00011.jpeg": 3284,
	"./logo.jpg": 1769,
	"./logoNoText.png": 4641,
	"./new1.jpg": 6751,
	"./new2.jpg": 6432,
	"./newMenu.jpeg": 6898,
	"./newer.jpg": 4297,
	"./section2.jpg": 8201,
	"./section3.jpg": 828,
	"./section5.jpg": 5610
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9291;